import { render } from "./ArticleHero.vue?vue&type=template&id=21d684c5&scoped=true"
import script from "./ArticleHero.vue?vue&type=script&lang=js"
export * from "./ArticleHero.vue?vue&type=script&lang=js"

import "./ArticleHero.vue?vue&type=style&index=0&id=21d684c5&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d684c5"]])

export default __exports__